<template>
  <div :key="appKey">
    <Modal v-if="alert" @close="alert = false" width="544px" height="174px">
      <h2 class="center">{{ alertText }}</h2>
    </Modal>

    <transition name="slide-fade">
      <Popup
        v-if="popup"
        @close="popup = false"
        width="444px"
        :title="popupTitle"
        :text="popupText"
        :type="popupType"
        :view="popupView"
      />
    </transition>

    <Modal v-if="confrim" @close="confrim = false" width="544px" height="174px">
      <h2 style="height: 100%"
        :style="confrimTextColor"
      >
        {{ confrimText }}
      </h2>
      <div class="button__wraper">
        <Button
          @click="confrimCalback"
          :loading="confrimLoading"
          class="btn-primary"
          width="96px"
          height="40px"
          :text="confrimAgreed"
        />
        <Button
          class="btn-secondary"
          width="96px"
          height="40px"
          text="Отмена"
          @click="confrim = false"
        />
      </div>
    </Modal>

    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import Button from "@/components/Button.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import Popup from "@/components/Popup.vue";
import { mapMutations, mapState } from "vuex";
import { debounce } from "@/utils/utils";

export default {
  components: {
    AuthLayout,
    DefaultLayout,
    Modal,
    Popup,
    Button,
  },
  data() {
    return {
      appKey: "",

      alert: false,
      alertText: "",

      confrim: false,
      confrimText: "",
      confrimAgreed: "",
      confrimTextColor: "",
      confrimCalback: null,
      confrimLoading: false,

      popup: false,
      popupTitle: "",
      popupText: "",
      popupType: "",
      popupView: "popup",
      popupDebounce: null,
    };
  },
  created() {
    window.addEventListener("unhandledrejection", (evt) => {
      const err = evt.reason;
      this.popupTitle = "Ошибка";

      this.popupText =
        err?.response?.data?.message ||
        (typeof evt.reason === "string" && evt.reason) ||
        "Повторите попытку позже.";
      this.popupType = "error";
      this.popup = true;
    });
    window.addEventListener("resize", () =>
      this.SET_WINDOW_WIDTH(window.innerWidth)
    );

    this.$root.alert = (text) => {
      this.alertText = text;
      this.alert = true;
    };

    this.$root.confrim = (text = "", callback = null, confrimAgreed = "Ок", color = "") => {
      this.confrimText = text;
      this.confrimAgreed = confrimAgreed;
      this.confrim = true;
      this.confrimTextColor = color
      this.confrimCalback = async () => {
        this.confrimLoading = true;
        try {
          await callback();
        } catch (err) {
          Promise.reject(err);
        }
        this.confrimLoading = false;
        this.confrim = false;
      };
    };

    this.$root.popup = (title, text, type, view = 'popup') => {
      this.popupTitle = title;
      this.popupText = text;
      this.popupType = type;
      this.popupView = view;
      this.popup = true;
    };
  },
  computed: {
    ...mapState(["windowWidth"]),
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
  },
  methods: {
    ...mapMutations(["SET_IS_MOBILE", "SET_WINDOW_WIDTH"]),
  },
  watch: {
    windowWidth: function () {
      this.SET_IS_MOBILE(this.windowWidth < 608);
    },
    popup(val) {
      if (!this.popupDebounce && val) {
        this.popupDebounce = debounce(() => {
          this.popup = false;
          this.popupDebounce = null;
        }, 5000);

        this.popupDebounce();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
